import { Component, Input, HostListener, ViewChild, OnInit,
    HostBinding, DoCheck, ElementRef, AfterViewInit } from '@angular/core';

import { CfCoreGalleryPreviewComponent } from './cf-core-gallery-preview.component';
import { CfCoreGalleryHelperService } from './cf-core-gallery-helper.service';

import { CfCoreGalleryOptions } from '../../../models/gallery/cf-core-gallery-options.model';
import { CfCoreGalleryImage } from '../../../models/gallery/cf-core-gallery-image.model';
export class CfCoreGalleryComponent implements OnInit, DoCheck, AfterViewInit {
     options: CfCoreGalleryOptions;
     images: CfCoreGalleryImage[];

    smallImages: string[];
    mediumImages: string[];
    bigImages: string[];
    descriptions: string[];

    oldImages: CfCoreGalleryImage[];
    oldImagesLength = 0;

    selectedIndex = 0;
    previewEnabled: boolean;

    currentOptions: CfCoreGalleryOptions;
private breakpoint: number = undefined;
private prevBreakpoint: number = undefined;
private fullWidthTimeout: any;

     preview: CfCoreGalleryPreviewComponent;

     width: string;
     height: string;
     left: string;
/**
 * @param {?} myElement
 */
constructor(private myElement: ElementRef) {}
/**
 * @return {?}
 */
ngOnInit() {
        // this.options = this.options.map(opt => new CfCoreGalleryOptions(opt));
        this.options = new CfCoreGalleryOptions(this.options);
        // this.currentOptions = this.options;
        this.sortOptions();
        this.setBreakpoint();
        this.setOptions();
        this.checkFullWidth();
    }
/**
 * @return {?}
 */
ngDoCheck(): void {
        if (this.images !== undefined && (this.images.length !== this.oldImagesLength)
            || (this.images !== this.oldImages)) {
            this.oldImagesLength = this.images.length;
            this.oldImages = this.images;
            this.setImages();
        }
    }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
        this.checkFullWidth();
    }
/**
 * @return {?}
 */
onResize() {
        this.setBreakpoint();

        if (this.prevBreakpoint !== this.breakpoint) {
            this.setOptions();
        }

        if (this.currentOptions.fullWidth) {

            if (this.fullWidthTimeout) {
                clearTimeout(this.fullWidthTimeout);
            }

            this.fullWidthTimeout = setTimeout(() => {
                this.checkFullWidth();
            }, 200);
        }
    }
/**
 * @return {?}
 */
getImageHeight(): string {
        return this.currentOptions.thumbnails ? this.currentOptions.imagePercent + '%' : '100%';
    }
/**
 * @return {?}
 */
getThumbnailsHeight(): string {
        if (this.currentOptions.image) {
            return 'calc(' + this.currentOptions.thumbnailsPercent + '% - '
            + this.currentOptions.thumbnailsMargin + 'px)';
        } else {
            return '100%';
        }
    }
/**
 * @return {?}
 */
getThumbnailsMargin(): string {
        return this.currentOptions.thumbnailsMargin + 'px';
    }
/**
 * @param {?} index
 * @return {?}
 */
openPreview(index: number): void {
        this.previewEnabled = true;
        this.preview.open(index);
    }
/**
 * @return {?}
 */
onClosePreview(): void {
        this.previewEnabled = false;
    }
/**
 * @param {?} index
 * @return {?}
 */
select(index: number) {
        this.selectedIndex = index;

        if (!this.currentOptions.image && this.currentOptions.thumbnails && this.currentOptions.preview) {
            this.openPreview(this.selectedIndex);
        }
    }
/**
 * @return {?}
 */
private checkFullWidth(): void {
        if (this.currentOptions.fullWidth) {
            this.width = document.body.clientWidth + 'px';
            this.left = (-(document.body.clientWidth -
                this.myElement.nativeElement.parentNode.innerWidth) / 2) + 'px';
        }
    }
/**
 * @return {?}
 */
private setImages(): void {
        this.smallImages = this.images.map(img => img.small);
        this.mediumImages = this.images.map(img => img.medium);
        this.bigImages = this.images.map(img => img.big);
        this.descriptions = this.images.map(img => img.description);
    }
/**
 * @return {?}
 */
private setBreakpoint(): void {

        this.prevBreakpoint = this.breakpoint;

        // const breakpoints = this.options.filter(opt => opt.breakpoint >= window.innerWidth)
        //     .map(opt => opt.breakpoint);

        // if (breakpoints.length) {
        //     this.breakpoint = breakpoints.pop();
        // } else {
        //     this.breakpoint = undefined;
        // }
    }
/**
 * @return {?}
 */
private sortOptions(): void {
        // this.options = [
        //     ...this.options.filter(a => a.breakpoint === undefined),
        //     ...this.options
        //         .filter(a => a.breakpoint !== undefined)
        //         .sort((a, b) => b.breakpoint - a.breakpoint)
        // ];
    }
/**
 * @return {?}
 */
private setOptions(): void {
        this.currentOptions = new CfCoreGalleryOptions(this.options);

        // this.options
        //     .filter(opt => opt.breakpoint === undefined || opt.breakpoint >= this.breakpoint)
        //     .map(opt => this.combineOptions(this.currentOptions, opt));

        this.width = this.currentOptions.width;
        this.height = this.currentOptions.height;
    }
/**
 * @param {?} first
 * @param {?} second
 * @return {?}
 */
private combineOptions(first, second) {
        Object.keys(second).map(val => first[val] = second[val] !== undefined ? second[val] : first[val]);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'cf-core-gallery',
    template: "<cf-core-gallery-image *ngIf=\"currentOptions?.image\" [style.height]=\"getImageHeight()\" [images]=\"mediumImages\" [clickable]=\"currentOptions?.preview\" [selectedIndex]=\"selectedIndex\" [arrows]=\"currentOptions?.imageArrows\" [arrowsAutoHide]=\"currentOptions?.imageArrowsAutoHide\" [swipe]=\"currentOptions?.imageSwipe\" [animation]=\"currentOptions?.imageAnimation\" [size]=\"currentOptions?.imageSize\" (onClick)=\"openPreview($event)\" (onActiveChange)=\"select($event)\"></cf-core-gallery-image> <cf-core-gallery-thumbnails *ngIf=\"currentOptions?.thumbnails\" [style.marginTop]=\"getThumbnailsMargin()\" [style.height]=\"getThumbnailsHeight()\" [images]=\"smallImages\" [selectedIndex]=\"selectedIndex\" [columns]=\"currentOptions?.thumbnailsColumns\" [rows]=\"currentOptions?.thumbnailsRows\" [margin]=\"currentOptions?.thumbnailMargin\" [arrows]=\"currentOptions?.thumbnailsArrows\" [arrowsAutoHide]=\"currentOptions?.thumbnailsArrowsAutoHide\" [clickable]=\"currentOptions?.image || currentOptions?.preview\" [swipe]=\"currentOptions?.thumbnailsSwipe\" (onActiveChange)=\"select($event)\"></cf-core-gallery-thumbnails> <cf-core-gallery-preview [images]=\"bigImages\" [descriptions]=\"descriptions\" [showDescription]=\"currentOptions?.previewDescription\" [swipe]=\"currentOptions?.previewSwipe\" [fullscreen]=\"currentOptions?.previewFullscreen\" [closeOnClick]=\"currentOptions?.previewCloseOnClick\" [keyboardNavigation]=\"currentOptions?.previewKeyboardNavigation\" (onClose)=\"onClosePreview()\" [class.cf-core-gallery-active]=\"previewEnabled\"></cf-core-gallery-preview>",
    styles: [":host { display: inline-block; } :host > * { float: left; } :host /deep/ * { box-sizing: border-box; } :host /deep/ .fa { color: white; font-size: 25px; position: absolute; z-index: 2000; } :host /deep/ .cf-core-gallery-clickable { cursor: pointer; } "],
    providers: [ CfCoreGalleryHelperService ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'options': [{ type: Input },],
'images': [{ type: Input },],
'preview': [{ type: ViewChild, args: [CfCoreGalleryPreviewComponent, ] },],
'width': [{ type: HostBinding, args: ['style.width', ] },],
'height': [{ type: HostBinding, args: ['style.height', ] },],
'left': [{ type: HostBinding, args: ['style.left', ] },],
'onResize': [{ type: HostListener, args: ['window:resize', ] },],
};
}

function CfCoreGalleryComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreGalleryComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfCoreGalleryComponent.ctorParameters;
/** @type {?} */
CfCoreGalleryComponent.propDecorators;
/** @type {?} */
CfCoreGalleryComponent.prototype.options;
/** @type {?} */
CfCoreGalleryComponent.prototype.images;
/** @type {?} */
CfCoreGalleryComponent.prototype.smallImages;
/** @type {?} */
CfCoreGalleryComponent.prototype.mediumImages;
/** @type {?} */
CfCoreGalleryComponent.prototype.bigImages;
/** @type {?} */
CfCoreGalleryComponent.prototype.descriptions;
/** @type {?} */
CfCoreGalleryComponent.prototype.oldImages;
/** @type {?} */
CfCoreGalleryComponent.prototype.oldImagesLength;
/** @type {?} */
CfCoreGalleryComponent.prototype.selectedIndex;
/** @type {?} */
CfCoreGalleryComponent.prototype.previewEnabled;
/** @type {?} */
CfCoreGalleryComponent.prototype.currentOptions;
/** @type {?} */
CfCoreGalleryComponent.prototype.breakpoint;
/** @type {?} */
CfCoreGalleryComponent.prototype.prevBreakpoint;
/** @type {?} */
CfCoreGalleryComponent.prototype.fullWidthTimeout;
/** @type {?} */
CfCoreGalleryComponent.prototype.preview;
/** @type {?} */
CfCoreGalleryComponent.prototype.width;
/** @type {?} */
CfCoreGalleryComponent.prototype.height;
/** @type {?} */
CfCoreGalleryComponent.prototype.left;
/** @type {?} */
CfCoreGalleryComponent.prototype.myElement;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
